import React from 'react';
import { motion } from 'framer-motion';
import { Home, ArrowLeft, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{ background: 'var(--gradient-hero)' }}
    >
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-10 w-72 h-72 bg-[var(--accent-primary)]/20 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-10 w-96 h-96 bg-[var(--accent-strong)]/15 rounded-full blur-3xl" />
      </div>

      <div className="container relative z-10 text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* 404 Number */}
          <div className="mb-8">
            <span className="text-[150px] md:text-[200px] font-bold leading-none bg-gradient-to-br from-[var(--accent-primary)] to-[var(--accent-strong)] bg-clip-text text-transparent">
              404
            </span>
          </div>

          {/* Message */}
          <h1 className="heading-2 mb-4">
            Oops! Page Not Found
          </h1>
          <p className="body-large max-w-md mx-auto mb-10">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/" className="btn-primary w-full sm:w-auto">
              <Home className="w-4 h-4" />
              Back to Home
            </Link>
            <Link to="/#contact" className="btn-secondary w-full sm:w-auto">
              <MessageCircle className="w-4 h-4" />
              Contact Us
            </Link>
          </div>

          {/* Quick Links */}
          <div className="mt-12 pt-8 border-t border-black/10">
            <p className="text-sm text-[var(--text-muted)] mb-4">Or try these popular pages:</p>
            <div className="flex items-center justify-center gap-6 flex-wrap">
              <Link to="/#services" className="text-[var(--accent-text)] hover:underline font-medium">
                Services
              </Link>
              <Link to="/#about" className="text-[var(--accent-text)] hover:underline font-medium">
                About Us
              </Link>
              <Link to="/#faq" className="text-[var(--accent-text)] hover:underline font-medium">
                FAQ
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
